/**
 * File: apps/qbench-cp/reactapp/src/shared/utils/permissions.js
 *
 * Purpose: Derives the customer portal's feature-flag permission map from cached portal-view
 *     configuration.
 *
 * Scope: Feature-flag/permission resolution consumed by `usePermissionCheck` and similar
 *     gating logic.
 *
 * Tags: customer-portal, portal-roles
 *
 * Overview: `getViewPermissions` reads the "portalView" entry from localStorage and, for
 *     every key defined in `PORTALVIEW_PERMISSION`, resolves a boolean permission by
 *     inverting that key's `hidden` flag (defaulting to visible/true when the value is nil
 *     or empty). Returns a flat object keyed by permission name.
 *
 * Exports: getViewPermissions
 */

import { PORTALVIEW_PERMISSION } from 'shared/constants/fields';
import { isNilOrEmptyIterables, safeJsonParse } from './functions';

export function getViewPermissions() {
  const portalView = safeJsonParse(localStorage.getItem('portalView')) ?? {};
  const userPermissions = Object.values(PORTALVIEW_PERMISSION).reduce(
    (acc, key) => {
      const val = portalView[key]?.hidden;
      return {
        ...acc,
        [key]: isNilOrEmptyIterables(val) ? false : !Boolean(val),
      };
    },
    {}
  );

  return userPermissions;
}
